// Action Cable provides the framework to deal with WebSockets in Rails.
// You can generate new channels where WebSocket features live using the `bin/rails generate channel` command.

import ActionCable from "actioncable"

const consumer = ActionCable.createConsumer()

export default consumer
